import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import awsLogo from "./aws_logo.png"
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Grid, CircularProgress, Typography, Button, TextField, Fade,Link, Box } from "@material-ui/core";

// styles
import useStyles from "./styles";


// store
import * as actions from "../../store/actions/actionIndex";
import { updateObject } from "../../helpers/utility";
import { checkLoginValidity } from "../../helpers/checkValidation";
import RmlLogin from "./RmlLogin";
import CzLogin from "./CzLogin";
import PasswordReset from "../../components/Modal/PasswordReset";
import { ToastContainer } from "react-toastify";
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';



function Login(props) {
	const data = window.Configs.var1;
	const [reset, setRest] = useState(false)
	//console.log("-----------Amit----------"+data);
	var classes = useStyles();
	const [valid, setValid] = useState({ isValid: true, errorMsg: "" });
	const [login, setLogin] = useState(false);
	const [open, setOpen] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const [controls, setControls] = useState({
		email: {
			value: "",
		},
		password: {
			value: "",
		},
	});

	const inputChangedHandler = (event, controlName) => {
		setRest(false)
		setValid(checkLoginValidity(event.target.value, controlName));
		const updatedControls = updateObject(controls, {
			[controlName]: updateObject(controls[controlName], {
				value: event.target.value,
			}),
		});
		setControls(updatedControls);
	};

	const checkKeycode = React.useCallback(
		(e) => {
			let keycode;
			try {
				if (window.event) keycode = window.event.keyCode;
				else if (e) keycode = e.which;

				if (keycode === 13 && valid.isValid) {
					props.onAgentValidate(controls.email.value)
					setRest(true)
				}
				return true;
			} catch (e) { }
		},
		[valid, controls, props]
	);

	React.useEffect(() => {
		document.onkeydown = checkKeycode;
		return () => {
			document.onkeydown = null;
		};
	}, [checkKeycode]);

	const submitHandler = () => {
		//event.preventDefault();
		props.onAgentValidate(controls.email.value)
		setRest(true)

	};

useEffect(() =>{

		if((props.responseCode === "1" ||props.responseCode === "2") && reset === true){
		setLogin(true);
		props.onAuth(controls.email.value, controls.password.value, "", "login",1);
		}
	},[props.responseCode, reset])

	const handleClose = () =>{
		setOpen(false);
		setRest(false);
		
	}
	const loginHandler = (action) => {
		//event.preventDefault();
		if (action === "no") {
			setControls({
				email: {
					value: "",
				},
				password: {
					value: "",
				},
			});
			props.onAuth(controls.email.value, controls.password.value, "", "newlogin",1);
		} else if (action === "yes") {
			props.onAuth(controls.email.value, controls.password.value, "", "relogin",1);
		}
	};
useEffect(()=>{
	if(props.isExpired === true && reset === true){
		setOpen(true)
	}


},[props.isExpired, reset])
	let d = new Date();
	let currentYear = d.getFullYear();

	const awsLoginHandler = () => {
  const awsLoginUrl = window?.Configs?.sso_login_url;
  if (awsLoginUrl) {
    window.location.href = awsLoginUrl;
  } else {
    console.error("AWS login URL is not defined in window.Configs");
  }
};


	return (
		<>
		<ToastContainer />
		
			<Grid container className={classes.container}>
                    {
                 window.Configs.rml_login === true ? (
                 <RmlLogin />
                      ) : (
                 <CzLogin />
 	                     )
                    }
				<div className={classes.formContainer}>
					<div className={classes.switchToAP}>
						<Link href={data} variant="button" underline="hover" size="large" style={{ flex: "auto",textAlign:'center' }}>Switch to old C-Zentrix Agent Panel</Link>
					</div>			
					<Typography variant="h1" className={classes.greeting}>
						Welcome, User
					</Typography>
					<div className={classes.form}>
						<React.Fragment>
							<TextField id="email" InputProps={{ classes: { underline: classes.textFieldUnderline, input: classes.textField, }, }} value={controls.email.value} onChange={(event) => inputChangedHandler(event, "email")} margin="normal" placeholder="Agent ID / Email Address" type="text" fullWidth /> 
						<TextField
						id="password"
						value={controls.password.value}
						onChange={(event) => inputChangedHandler(event, "password")}
						margin="normal"
						placeholder="Password"	
						type={showPassword ? "text" : "password"}
						fullWidth
						InputProps={{
							classes: {
							underline: classes.textFieldUnderline,
							input: classes.textField,
							},
							endAdornment: (
							<InputAdornment position="end">
								<IconButton onClick={() => setShowPassword(!showPassword)} edge="end" style={{ padding: "4px" }}>
								{showPassword ? <Visibility style={{width: "20px"}}/> : <VisibilityOff style={{width: "20"}}/>}
								</IconButton>
							</InputAdornment>
							),
						}}
						/>

							{props.error !== "ReloginAgent" && (
								<div className={classes.formButtons}>
									<Button disabled={controls.email.value.length === 0 || controls.password.value.length === 0 || !valid.isValid} onClick={() => submitHandler()} variant="contained" color="primary" size="large" style={{ flex: "auto" }}>
										Login
										{props.loading ? <CircularProgress size={26} className={classes.loginLoader} /> : ""}
									</Button>
								</div>
							)}

							 {/* AWS Login Button */}
								{window.Configs.sso_enable_flag === 1 && (
									<>
										{/* OR separator */}
										<div className={classes.separator}>
										<span>OR continue with</span>
										</div>

										<div className={classes.formButtons}>
										<Button
											onClick={() => awsLoginHandler()}
											variant="outlined"
											size="large"
											className={classes.awsButton}
											startIcon={<img src={awsLogo} alt="AWS Logo" className={classes.awsLogo} />}
										>
											Sign in with AWS
										</Button>
										</div>
									</>
								)}
								{props.reason !== "" && props.responseCode !== "2"
								?
							<Fade in={props.reason !== "" }>
							<Typography color="secondary" className={classes.errorMessage}>
								{props.reason !== "" ? props.reason : ""}
							</Typography>
							</Fade>
							:
							<Fade in={(props.error && login) || !valid.isValid}>
								{props.error || !valid.isValid ? (
									<Typography color="secondary" className={classes.errorMessage}>
										{valid.errorMsg !== "" ? valid.errorMsg : login ? (props.error === "ReloginAgent" ? "Agent is already login. Do you want to create new session?" : props.error) : ""}
									</Typography>
								) : (
									<Typography color="secondary" className={classes.errorMessage}>
										Something is wrong with your login id or password
									</Typography>
								)}			
							</Fade>
}


							{props.error === "ReloginAgent" && (
								<>
									<div className={classes.formButtons}>
										<Button onClick={() => loginHandler("yes")} variant="contained" color="primary" size="large" style={{ flex: "auto" }}>
											Yes
											{props.loading ? <CircularProgress size={26} className={classes.loginLoader} /> : ""}
										</Button>
									</div>
									<div className={classes.formButtons}>
										<Button onClick={() => loginHandler("no")} variant="contained" color="primary" size="large" style={{ flex: "auto" }}>
											No
											{props.loading ? <CircularProgress size={26} className={classes.loginLoader} /> : ""}
										</Button>
									</div>
								</>
							)}
						</React.Fragment>
						
					</div>
					
					<Typography color="primary" className={classes.copyright}>
						© {currentYear} . All rights reserved.
					</Typography>
				</div>
				{props.isExpired && (
				<PasswordReset agentId={controls.email.value} soonExpired={false} open={open} handleClose={handleClose} />
			)}
			</Grid>
			</>
	);
}

const mapStateToProps = (state) => {
	return {
		loading: state.agentData.loading,
		error: state.agentData.error,
		isAuthenticated: state.agentData.loggedIn,
		loginWait: state.agentData.loginWait,
		loginType: state.agentData.loginType,
		responseCode: state.resetData.responseCode,
		reason: state.resetData.reason,
		isExpired: state.resetData.isExpired,
		restError: state.resetData.error,
		//authRedirectPath: state.agentData.authRedirectPath,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
	onAgentValidate: (email) => dispatch(actions.checkValidateAgent(email)),
	onAuth: (email, password, extension, action, session_flag) => dispatch(actions.agentLogin(email, password, extension, action, session_flag)),
		//onSetAuthRedirectPath: () => dispatch(actions.setAuthRedirectPath('/')),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
